import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { STRAPI_URL } from "../env";

export async function fetchViewConfiguration(
  type: "dashboard" | "overview" | "project-common"
): Promise<
  | {
      tabs: {
        id: number;
        title: string;
        rows: {
          id: number;
          columnCount: number;
          columns: {
            columnIndex: number;
            componentId: string;
          }[];
        }[];
      }[];
      displayTabs?: boolean;
      canEdit?: boolean;
      isAiEnabled?: boolean;
      type: "dashboard" | "overview" | "project-common";
    }
  | undefined
> {
  try {
    const response = await fetch(`${STRAPI_URL}/view-configuration/${type}`, {
      credentials: "include",
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const json = (await response.json()) as {
      tabs: {
        id: number;
        title: string;
        rows: {
          id: number;
          columnCount: number;
          columns: {
            columnIndex: number;
            componentId: string;
          }[];
        }[];
      }[];
      displayTabs?: boolean;
      canEdit?: boolean;
      isAiEnabled?: boolean;
      type: "dashboard" | "overview" | "project-common";
    };

    return json;
  } catch {
    return;
  }
}

export async function createViewConfiguration(configuration: {
  tabs: {
    id: number;
    title: string;
    rows: {
      id: number;
      columnCount: number;
      columns: {
        columnIndex: number;
        componentId: string;
      }[];
    }[];
  }[];
  displayTabs?: boolean;
  canEdit?: boolean;
  isAiEnabled?: boolean;
  type: "dashboard" | "overview" | "project-common";
}): Promise<
  | {
      tabs: {
        id: number;
        title: string;
        rows: {
          id: number;
          columnCount: number;
          columns: {
            columnIndex: number;
            componentId: string;
          }[];
        }[];
      }[];
      displayTabs?: boolean;
      canEdit?: boolean;
      isAiEnabled?: boolean;
      type: "dashboard" | "overview" | "project-common";
    }
  | undefined
> {
  try {
    const response = await fetch(`${STRAPI_URL}/view-configuration`, {
      credentials: "include",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(configuration),
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }

    const json = (await response.json()) as {
      tabs: {
        id: number;
        title: string;
        rows: {
          id: number;
          columnCount: number;
          columns: {
            columnIndex: number;
            componentId: string;
          }[];
        }[];
      }[];
      displayTabs?: boolean;
      canEdit?: boolean;
      isAiEnabled?: boolean;
      type: "dashboard" | "overview" | "project-common";
    };

    return json;
  } catch {
    return;
  }
}

export function mapViewConfiguration(viewConfiguration?: {
  tabs: {
    id: number;
    title: string;
    rows: {
      id: number;
      columnCount: number;
      columns: {
        columnIndex: number;
        componentId: string;
      }[];
    }[];
  }[];
  displayTabs?: boolean;
  canEdit?: boolean;
  isAiEnabled?: boolean;
  type: "dashboard" | "overview" | "project-common";
}) {
  return {
    canEdit: viewConfiguration?.canEdit ?? true,
    displayTabs: viewConfiguration?.displayTabs ?? true,
    tabs:
      viewConfiguration?.tabs && viewConfiguration.tabs.length > 0
        ? viewConfiguration.tabs
        : [
            {
              id: 0,
              title:
                getLocalizedMessage(
                  (typeof window !== "undefined" &&
                    (
                      window as Window & {
                        __PIMO_APP_STATE__?: { language?: string };
                      }
                    )?.__PIMO_APP_STATE__?.language) ||
                    "en",
                  "tab1"
                ) || "Tab 1",
              rows: [
                {
                  id: 0,
                  columnCount: 1,
                  columns: [],
                },
              ],
            },
          ],
  };
}
